export const getShopUrl = (newShop: boolean) => (newShop ? '/shop-new' : '/shop');
